<div class="header">
<div class="list" *ngIf="settlementDetail">
  <app-render-list-item class="list_item" *ngFor="let item of settlementDetail" [item]="item" [backendListRender]="backendListRender">
  </app-render-list-item>
</div>
<div class="header_left">
    <div class="header_title" [innerHtml]="title" *ngIf="!titleWithShipment"></div>
    <div class="header_title" *ngIf="titleWithShipment">
      Shipment: 
      <span class="header_title-link">
        <a *ngIf="titleWithShipment.status !=='DRAFT'" target="_blank"
      [attr.href]="titleWithShipment.url">
        {{titleWithShipment.amazonShipmentId ? titleWithShipment.amazonShipmentId : titleWithShipment.shipmentHeaderId}} 
      </a>
      <a *ngIf="titleWithShipment.status =='DRAFT'" class="draft">  {{titleWithShipment.amazonShipmentId ? titleWithShipment.amazonShipmentId : titleWithShipment.shipmentHeaderId}} 
      </a>
      <i
        class="fal header_title-link--icon"
        [ngClass]="{ 'fa-copy': !copied, 'fa-check': copied }"
        [cdkCopyToClipboard]="titleWithShipment.amazonShipmentId ? titleWithShipment.amazonShipmentId : titleWithShipment.shipmentHeaderId"
        (cdkCopyToClipboardCopied)="copy($event)"
      ></i>
      </span>
      <div class="star" [ngClass]="{'active': titleWithShipment.isStarred}" *ngIf="headerService.isNewFlow">
        <i class="fas fa-star"></i>
      </div>
       Status: {{titleWithShipment?.status}} 
    </div>
    <!-- <div class="header_breadcrumbs">
      <div class="header_breadcrumb">Shipyard</div>
      <div class="header_breadcrumb">Sku List</div>
    </div> -->
  </div>
  <div class="header_actions">
    <div class="header_action">
      <div class="d-flex align-items-center me-4" *ngIf="router.url =='/priceyard/pricing-pulse'">
        <label class="header_action--pricingUpdate" *ngIf="headerService.updateRefreshTime">Pricing Pulse Last Updated <span>: {{headerService?.updateRefreshTime| date:'hh:mm a'}}</span></label>
        <app-button [buttonSize]="'action'" (click)="refreshNotifications()"><i class="far fa-sync me-1"></i> Refresh Now</app-button>
      </div>
      <div
        class="processing"
        *ngIf="processes.length"
        #processingElement
        (click)="openProcesses()"
      >
        <div class="processing_title">
          {{ processes.length }} Process(es) running
        </div>
        <!-- <div class="processing_status">
          Shipment sync in progress
        </div> -->
        <div class="processing_icon">
          <i class="fal fa-chevron-down"></i>
        </div>
      </div>
    </div>
    <!-- <div class="header_action"><i class="fal fa-search"></i></div> -->
    <!-- <div
      class="header_action"
      [ngClass]="{ header_action: hasUpdates }"
      (click)="openUpdatesDialog()"
    >
      <i class="fal fa-bell"></i>
    </div> -->
  </div>
  <div class="shipment_btn_menu" [ngClass]="{ disable: total === 0 }"  
  *ngIf="showIcon"
    [matMenuTriggerFor]="unmaapedSku"> <i class="far fa-bell"></i>
    <span class="d-flex align-items-center justify-content-center">{{total}}</span>
  </div>
  <div class="shipment_btn_menu" [ngClass]="{ disable: total === 0 }"  *ngIf="(nonDeductedShipmentCount && title == 'Shipments List' && selectedType == 'Amazon' )"
    [matMenuTriggerFor]="nonDeductedShipmentMenu"> <i class="far fa-bell"></i>
    <span class="d-flex align-items-center justify-content-center"> 1 
    </span>
  </div>
  <div class="header_account-selector">
    <div class="input-container">
      <mat-select
        [(ngModel)]="selectedAccount"
        (ngModelChange)="accountsChanged()"
        class="input-container_input input-container_input--select input-container_input--thin p-0 header-select-input"
        [disabled]="accountDropdownDisabled"
        [matTooltip]="accountDropdownDisabled ? 'Current page is not account-specific and shows data for all accounts' : '' "
        disableOptionCentering panelClass="panelClass"
      >
      <mat-select-trigger>
        <mat-icon class="input-container_sm-icon">
        <app-channal-icon
        [channal]="selectedType"
        [gray]="true"
      >
    </app-channal-icon>
       </mat-icon>
       <span> {{selectedAccount}}</span>
      </mat-select-trigger> 
        <mat-option
          *ngFor="let account of accounts | async"
          [value]="account.name"
        >
        <mat-icon>
          <app-channal-icon
          [channal]="account.type"
          [gray]="true"
        >
      </app-channal-icon>
      </mat-icon>   
          <span class="input-container_option-text">
          {{ account.name }}
        </span>
      </mat-option>
        
        

        <!-- <mat-option
          *ngFor="let account of allMarketPlaces | async"
          [value]="account.name"
        >
          {{ account.name }}
        </mat-option> -->
      </mat-select>
    </div>
  </div>
</div>

  
<mat-menu #unmaapedSku="matMenu" class="mat-menu-primary"  xPosition="before">
  <button mat-menu-item  *ngIf="unMappedSku.length && userInfo?.isPlanYard"  (click)="openUnmappedSku()"><i class="far fa-exclamation-triangle me-2"></i>{{unMappedSku[0]?.count | number: "1.0-2"}} {{unMappedSku[0]?.value}} SKU's</button>
  <button mat-menu-item  [matMenuTriggerFor]="duplicateSku" *ngIf="unMappedSku.length > 1"><i class="far fa-exclamation-triangle me-2"></i>{{ totalDuplicateSku }} Duplicate SKU's</button>
  <button mat-menu-item *ngIf="userInfo?.isPlanYard"  (click)="openUnmappedSku(true)"><i class="far fa-exclamation-triangle me-2"></i> {{itemStockWithNoMappingCount || 0}} Unmapped Products</button>
  <button mat-menu-item *ngIf="userInfo?.isPlanYard" (click)="openMappedSkus()" > <i class="far fa-exclamation-triangle me-2"></i> {{mappedWithSyncOffCount || 0}} Mapped with Sync off</button>
  <button mat-menu-item *ngIf="userInfo?.isShipyard || userInfo?.isPlanYard" (click)="openUnmappedSku(false,true)"> <i class="far fa-exclamation-triangle me-2"></i> {{skuNotOnSellerCount || 0}} Skus not found</button>
</mat-menu>

<mat-menu #nonDeductedShipmentMenu="matMenu" class="mat-menu-primary"  xPosition="before">
  <button mat-menu-item (click)="openUnmappedSku(false,false,true)"> <i class="far fa-exclamation-triangle me-2"></i> {{nonDeductedShipmentCount || 0}} Shipments Not Deducted</button>
</mat-menu>

<mat-menu #duplicateSku="matMenu" class="mat-menu-primary">
  <ng-template matMenuContent >
  <button mat-menu-item  mat-menu-item  *ngFor="let sku of duplicateSkuCount" (click)="openDuplicateSku(sku)"> {{sku.account}} ({{sku.value}})</button>
  </ng-template>  
</mat-menu>
